import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import type { AssembleCarouselDescription } from '../types';

interface CoordinatedItemsHeaderProps {
  description: AssembleCarouselDescription;
}

/** 코디 아이템 헤더 — 아이콘 + 타이틀 (서버 carousel_description 사용) */
export const CoordinatedItemsHeader = ({ description }: CoordinatedItemsHeaderProps) => {
  if (!description.title) return null;

  return (
    <Flex.Row
      alignItems="center"
      padding={{ horizontal: 16, top: 4, bottom: 12 }}
    >
      {description.image_url && (
        <Flex margin={{ right: 4 }}>
          <RemoteImage uri={description.image_url} width={16} height={16} />
        </Flex>
      )}
      <Typography type="subtitle3" color="content_secondary">
        {description.title}
      </Typography>
    </Flex.Row>
  );
};
